var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.145a2.193 2.193 0 0 0-2.186-2.205c-.592 0-1.13.235-1.524.614-1.505-1.084-3.566-1.789-5.86-1.88l1.004-4.734 3.261.705c.036.83.717 1.5 1.56 1.5.86 0 1.559-.705 1.559-1.573 0-.867-.7-1.572-1.56-1.572-.609 0-1.146.361-1.397.886l-3.638-.778a.379.379 0 0 0-.287.055.352.352 0 0 0-.161.253l-1.112 5.277c-2.33.072-4.426.777-5.95 1.88a2.192 2.192 0 0 0-1.523-.615A2.193 2.193 0 0 0 2 12.163a2.2 2.2 0 0 0 1.29 2.006 4.04 4.04 0 0 0-.053.668C3.237 18.235 7.16 21 12 21s8.763-2.747 8.763-6.163a4.21 4.21 0 0 0-.053-.668A2.227 2.227 0 0 0 22 12.145ZM6.982 13.717c0-.868.699-1.572 1.56-1.572.86 0 1.558.704 1.558 1.572 0 .867-.699 1.572-1.559 1.572-.86.018-1.559-.705-1.559-1.572Zm8.728 4.175c-1.076 1.084-3.119 1.156-3.71 1.156-.61 0-2.652-.09-3.71-1.156a.406.406 0 0 1 0-.579.398.398 0 0 1 .574 0c.68.687 2.114.922 3.136.922 1.021 0 2.473-.235 3.136-.922a.398.398 0 0 1 .574 0 .443.443 0 0 1 0 .579Zm-.287-2.585c-.86 0-1.56-.705-1.56-1.572 0-.867.7-1.572 1.56-1.572.86 0 1.56.704 1.56 1.572 0 .85-.7 1.572-1.56 1.572Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.31880e4f0e035cdac1d1d77a2f08c8dc.svg";
export { ForwardRef as ReactComponent };